<template>
  <div class="mb-12 text-center">
    <MessageSentSvg class="w-64" />
    <p class="mt-4 text-2xl text-dark">Message envoyé&nbsp;!</p>
    <a
      v-if="store.conversation"
      class="btn btn-primary btn-lg mt-8"
      data-bs-dismiss="modal"
      data-controller="chat-opener"
      data-action="click->chat-opener#trigger"
      :data-chat-opener-conversation-id-value="store.conversation.id"
      :data-chat-opener-interlocutor-id-value="store.conversation.interlocutor.id"
      @click="reloadPage"
    >
      Voir la conversation
    </a>
  </div>
</template>

<script setup>
import { getCurrentInstance, onBeforeMount } from 'vue'
import MessageSentSvg from './MessageSentSvg.vue'
import { useMainStore } from '../stores/main'
import { useApi } from '@/apps/shared/composables'
const store = useMainStore()
const rootInstance = getCurrentInstance().root
const api = useApi()

onBeforeMount(async () => {
  if (!rootInstance.data.createdConversationId) return

  const { data: body } = await api.get('/api/conversations/' + rootInstance.data.createdConversationId)
  store.conversation = body.conversation
})

const reloadPage = () => {
  if (store.loggedUser) {
    const currentUrl = new URL(window.location.href)
    currentUrl.searchParams.set('openChat', 1)
    if (store.loggedUser.confirmed_at) currentUrl.searchParams.set('conversationId', store.conversation.id)

    window.location.href = currentUrl.href
  } else {
    document.dispatchEvent(new CustomEvent('chat:refresh_lists'))
  }
}
</script>
